import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import MarketingPage from './components/MarketingPage';
import SignUp from './components/SignUp';
import PricingPage from './components/PricingPage';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import Profile from './components/Profile';
import Login from './components/Login';
import Manage from './components/Manage';
import Header from './components/Header';
import BuyCallingCard from './components/BuyCallingCard';
import useIsAuthenticated from './hooks/useIsAuthenticated';

const msalConfig = {
  auth: {
    clientId: "79cb2285-295a-4b22-9526-44eb96ee503d",
    authority: "https://callgeept.b2clogin.com/callgeept.onmicrosoft.com/B2C_1_SignUp_SignIn",
    knownAuthorities: ["callgeept.b2clogin.com"],
    redirectUri: "https://callgeept.ai/",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <div className="App">
      <MsalProvider instance={msalInstance}>
        <Header />
        <Routes>
          <Route path="/" element={<MarketingPage />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/buycallingcard" element={<BuyCallingCard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/manage" element={<ProtectedRoutes><Manage /></ProtectedRoutes>} />
          <Route path="/profile" element={<ProtectedRoutes><Profile /></ProtectedRoutes>} />
          <Route path="*" element={<h1>404: Not Found</h1>} />
        </Routes>
      </MsalProvider>
    </div>
  );
}

function ProtectedRoutes({ children }) {
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return children;
  }

  return <Navigate to="/login" />;
}

export default App;
